<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="微信用户管理">
      <template>
        <el-button size="small" type="primary" @click="newlyAdded"
          >新增</el-button
        >
      </template>
    </pageTitle>
    <div style="height: 20px"></div>

    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>

          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 0
                  ? 'iconfont icon-jihuo'
                  : 'iconfont icon-lock'
              "
            ></i
            >{{ row.row.status == 0 ? "锁定" : "激活" }}
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
        </div>
      </template>
    </basicList>

    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

  <script>
import { wxGetList, wxActiveOne, wxLockOne, wxDelOne } from "@/api/base";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "weChatUsers",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      roleId: 0,
      compId: 0,

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },

      // 列表组件参数
      basicListconfig: {
        loading: false,
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width:100,
          },
          {
            label: "头像",
            prop: "wx_headimgurl",
            type: "img",
          },
          {
            label: "昵称",
            prop: "nick_name",
          },
          {
            label: "别名",
            prop: "name",
          },
          {
            label: "粉丝状态",
            prop: "fansStatus",
          },
          {
            label: "推荐渠道",
            prop: "channel",
          },
          {
            label: "状态",
            prop: "status",
            filter: "wechatStatus",
          },
          {
            label: "关注时间",
            prop: "follow_time",
          },
          {
            label: "取关时间",
            prop: "unfollow_time",
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    // 初始化列表内容
    this.getlist();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wxLockOne({ id: row.id, comp_id: this.compId }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wxActiveOne({ id: row.id, comp_id: this.compId }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wxDelOne({ id: row.id, comp_id: this.compId }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = this.compId;
      wxGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

  <style>
</style>



// WEBPACK FOOTER //
// src/views/weChatUsers/index.vue